import { render, staticRenderFns } from "./MailMagazineList.vue?vue&type=template&id=724bf8fa&scoped=true&"
import script from "./MailMagazineList.vue?vue&type=script&lang=js&"
export * from "./MailMagazineList.vue?vue&type=script&lang=js&"
import style0 from "./MailMagazineList.vue?vue&type=style&index=0&id=724bf8fa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724bf8fa",
  null
  
)

export default component.exports